export const API_WEATHER_KEY = window.apiWeatherKey || '59875e3392c7f8a6414b31f4eb0ade11'
export const API_WEATHER_URL = window.apiWeather || 'http://api.openweathermap.org/data/2.5/weather'